import React from 'react'

const Example: React.FC = () => {
	return (
		<div className='timeline--example timeline-section'>
			<div className='timeline--example__event'>
				<div className='example--gallery'>
					<img src='/images/timeline/example-main.png' alt='Mummy ministering in NLWC church' />
					<img src='/images/timeline/example.png' alt='Mummy ministering in NLWC church also' />
				</div>

				<div className='example--content'>
					<h5>An example!</h5>

					<p>
						And now, she has become for us an example worthy of emulation and double honour. She is our beautiful mother, one we
						would forever be grateful for
					</p>
				</div>
			</div>
		</div>
	)
}

export default Example
